import { AxiosError } from 'axios';

// Constants
import {
    SCAFFOLD_DATA_LOAD_REQUESTED,
    SCAFFOLD_DATA_LOAD_SUCCEEDED,
    SCAFFOLD_DATA_LOAD_FAILED,
    SCAFFOLD_DATA_LOAD_CANCELED
} from './constants';

// Types
import {
    RequestLoadScaffoldDataAction,
    SucceededLoadScaffoldDataAction,
    FailedLoadTimesheetsAction,
    CanceledLoadScaffoldDataAction
} from './types';

export function requestLoadScaffoldData(): RequestLoadScaffoldDataAction {
    return {
        type: SCAFFOLD_DATA_LOAD_REQUESTED
    };
}

// TODO: refactor scaffoldDataLoaded to succeededLoadScaffoldData
export function scaffoldDataLoaded(
    response: any
): SucceededLoadScaffoldDataAction {
    return {
        type: SCAFFOLD_DATA_LOAD_SUCCEEDED,
        response,
        payload: response,
        meta: {
            schemaName: 'scaffoldData'
        }
    };
}

export function failedLoadScaffoldData(
    error: AxiosError
): FailedLoadTimesheetsAction {
    return {
        type: SCAFFOLD_DATA_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function canceledLoadScaffoldData(): CanceledLoadScaffoldDataAction {
    return {
        type: SCAFFOLD_DATA_LOAD_CANCELED
    };
}
